import { useRef, useCallback } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

const SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY_V2?.trim()

export default function RecaptchaV2({ onVerify, onError }) {
  const recaptchaRef = useRef(null)

  const handleChange = useCallback((token) => {
    if (token) {
      onVerify({ token })
    }
  }, [onVerify])

  const handleExpired = useCallback(() => {
    onVerify({ token: null })
    onError?.('reCAPTCHA expired. Please verify again.')
  }, [onVerify, onError])

  const handleError = useCallback(() => {
    onError?.('reCAPTCHA error. Please try again.')
  }, [onError])

  if (!SITE_KEY) {
    return (
      <div className="bot-protection bot-protection--warning">
        reCAPTCHA not configured (missing site key)
      </div>
    )
  }

  return (
    <div className="bot-protection bot-protection--recaptcha-v2">
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={SITE_KEY}
        onChange={handleChange}
        onExpired={handleExpired}
        onErrored={handleError}
      />
    </div>
  )
}
